<template><div><h1 id="adressbereinigung" tabindex="-1"><a class="header-anchor" href="#adressbereinigung"><span>Adressbereinigung</span></a></h1>
<p>Adressbereinigung — Adressen manuell bereinigen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Ansicht können die Adressen, die zuvor durch den Administrator <RouteLink to="/referenz/refs/ft.refdata.adressbereinigungadmin.html" title="Adressbereinigung (Administrator)">Adressbereinigung (Administrator)</RouteLink> zugewiesen wurden, hier manuell bereinigt werden.</p>
<p>Pfad: <code v-pre>Personen → Datenpflege → Bearbeitung manuell → Manuelle Bereinigung</code></p>
<h2 id="datenfelder-personenbereinigung" tabindex="-1"><a class="header-anchor" href="#datenfelder-personenbereinigung"><span>Datenfelder (Personenbereinigung)</span></a></h2>
<dl>
<dt>Filter</dt>
<dd>Zugewiesene Filter</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der zugewiesenen Filter</dd>
<dt>zu bearbeiten</dt>
<dd>Anzahl Datensätze (Personen) die zu bearbeiten sind</dd>
<dt>zu bearbeiten (Gruppe)</dt>
<dd>Anzahl Personen die, die Gruppe zu bearbeiten hat. Mit Gruppe sind alle Benutzer die an diesem Filter arbeiten, gemeint.</dd>
</dl>
<h2 id="datenfelder-personen" tabindex="-1"><a class="header-anchor" href="#datenfelder-personen"><span>Datenfelder (Personen)</span></a></h2>
<dl>
<dt>Check-Box (ohne Label)</dt>
<dd>Durch das anhaken der Check-Box wird der Datensatz als bearbeitet markiert.</dd>
<dt>Personen-ID</dt>
<dd>Personen-ID der zu bereinigenden Person.</dd>
<dt>Name und Adresse</dt>
<dd>Name und Adresse der zu bereinigenden Person.</dd>
<dt>Status</dt>
<dd>Dropdown-Menu, zeigt den Status der Bearbeitung an. Leer = noch nicht bearbeitet, bearbeitet = Datensatz ist als bearbeitet markiert.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/manual/customer/adressbereinigung.html#Adressbereinigung" title="1. Adressbereinigung (manuell)">Adressbereinigung</RouteLink> , <RouteLink to="/referenz/refs/ft.refdata.adressbereinigungadmin.html" title="Adressbereinigung (Administrator)">Adressbereinigung (Administrator)</RouteLink></p>
</div></template>


